import type { EntityHeaderConfig } from '@pesto/features/src/EntityProfile/types/EntityHeader.types';

import { formatPhoneNumber } from '@pesto/utils';
import { Mail, Phone, Sparkles, User } from 'lucide-react';

import type { UserDetailViewModel } from './toUserDetail';

const buildDisplayName = (user: UserDetailViewModel) => {
  return [user.firstName, user.middleName, user.lastName].filter(Boolean).join(' ').trim() || '—';
};

export const buildUserHeaderConfig = (user: UserDetailViewModel): EntityHeaderConfig => {
  const meta: EntityHeaderConfig['meta'] = [];

  if (user.email) meta.push({ icon: Mail, value: user.email });

  if (user.phone) meta.push({ icon: Phone, value: formatPhoneNumber(user.phone) });

  const badges: EntityHeaderConfig['badges'] = [];

  if (user.isFriendsAndFam) {
    badges.push({ label: 'Friends & Family', variant: 'outline', icon: Sparkles });
  }

  return {
    avatar: { icon: User },
    title: buildDisplayName(user),
    secondary: { label: 'ID', value: user.id, mono: true },
    meta,
    badges,
  };
};
